import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SideBar from '../pages/Dashboard/SideBars/SideBar';
import routes from '../Routes/routes';

const DashboardLayout = () => {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false); // InitialState for SideBar
    //No padding pages
    const noPaddingPages = ['/dashboard/employee/work-office', '/dashboard/employee/zones/show-devices', routes.materialRequest.scanner];
    const isPageWithoutPadding = noPaddingPages.includes(location.pathname);
    // to setProfilebgimage for profile
    let showBar = true;
   const currentUrl = window.location.href;

   if (
       currentUrl.indexOf(routes.foodieKitchen.list) > -1 ||
       currentUrl.indexOf(routes.deliveredServices.list) > -1
   ) {
       showBar = false;
   }

    return (
        <div>
            <div>
                <div className='d-flex'>
                    {showBar && (
                        <div className={`custom-sidebar ${isMenuOpen ? 'largeMenu' : 'shortMenu'} `}>
                            <div className='position-fixed'>
                                <SideBar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
                            </div>
                        </div>
                    )}

                    <main className={`${isMenuOpen ? 'siOpen' : 'noOpen'} ${showBar ? 'showBar' : 'hideBar'}`}>
                        <div className={`container-outlet ${isPageWithoutPadding ? 'no-padding' : ''}`}>
                            <Outlet />
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default DashboardLayout;
